import React from "react";
import PropTypes from "prop-types";
import { graphql, withPrefix } from "gatsby";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import SEO from "../components/seo";
import useSiteMetadata from "../components/SiteMetadata";
import { IndexPageTemplate } from "../templates/index-page";

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;
  const { siteUrl, description } = useSiteMetadata();
  // Ahora el flag viene del frontmatter de index.md
  const featureFlag = frontmatter.featureFlag === true;
  const funnelPromoCard = data.funnel?.frontmatter?.promoCard || null;
  const promoCard = featureFlag
    ? funnelPromoCard || frontmatter.promoCard
    : frontmatter.promoCard;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Cris Web",
    description,
    url: siteUrl,
    logo: "https://www.crisweb.me/static/slogan-n-back-dbaf0b2726fe6bdbe648b3f900f064a2.svg",
  };

  return (
    <Layout>
      <SEO title="Home" schemaMarkup={schema} />
      <Helmet>
        <title>{frontmatter.title}</title>
        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={frontmatter.title} />
        <meta property="og:url" content={siteUrl} />
        <meta
          property="og:image"
          content={`${withPrefix("/")}img/img-content.png`}
        />
        <meta property="og:locale" content="es_ES" />
        <link rel="canonical" href={siteUrl} />
      </Helmet>
      <IndexPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        heading={frontmatter.heading}
        subheading={frontmatter.subheading}
        mainpitch={frontmatter.mainpitch}
        description={frontmatter.description}
        intro={frontmatter.intro}
        promoCard={promoCard}
      />
    </Layout>
  );
};

IndexPage.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        featureFlag: PropTypes.bool,
      }),
    }),
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
    funnel: PropTypes.shape({
      frontmatter: PropTypes.shape({
        promoCard: PropTypes.object,
      }),
    }),
  }),
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexPage {
    # siteMetadata ya no es necesario para el flag
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        image
        heading
        subheading
        mainpitch {
          title
          description
        }
        description
        intro {
          blurbs {
            image
            text
          }
          heading
          description
        }
        promoCard {
          title
          image
          ctaLink
          ctaText
        }
        featureFlag
      }
    }
    funnel: markdownRemark(
      frontmatter: {
        templateKey: { eq: "landing-funnel-page" }
        slug: { eq: "arquitectura-software" }
      }
    ) {
      frontmatter {
        promoCard {
          title
          image
          ctaLink
          ctaText
        }
      }
    }
  }
`;
